// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
export const firebaseConfig = {
    apiKey: "AIzaSyDpwdq1gsnOz4BlP8WW9oPozYPSmWniDYQ",
    authDomain: "react-pet-dugilan.firebaseapp.com",
    projectId: "react-pet-dugilan",
    storageBucket: "react-pet-dugilan.appspot.com",
    messagingSenderId: "1080376899039",
    appId: "1:1080376899039:web:356eaa2da0935ac8ea806a",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

export const storage = getStorage(app);
